import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IChecklist2UnitWithPeriodModel } from '@fi-shared/checklist/checklist-v2';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiChecklistViewerSnackbarColorClass } from '@fi-shared/checklist/fi-checklist2-viewer/disabled-viewer-warning-snackbar/disabled-viewer-warning-snackbar.component';

@Component({
    selector: 'fi-checklist2-viewer-schedule-not-shared',
    templateUrl: './checklist-viewer-schedule-not-shared.component.html',
    styleUrls: ['./checklist-viewer-schedule-not-shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-viewer-schedule-not-shared' },
    standalone: false,
})
export class FiChecklist2ViewerScheduleNotShared {
    @Input({ required: true }) auditMode: boolean;
    @Input() checklistUnitsSchedulePeriods: IChecklist2UnitWithPeriodModel[] = [];
    @Output() onSetNewBusinessUnit = new EventEmitter<INameIdObj>();
    isUnitSelectionStep: boolean = false;
    selectedBusinessUnitId: number;

    toggleUnitSelectionStep() {
        this.isUnitSelectionStep = !this.isUnitSelectionStep;
    }

    setNewBusinessUnit() {
        this.onSetNewBusinessUnit.emit({
            Id: this.selectedBusinessUnitId,
            Name: this.getSelectedChecklistUnitName(),
        });
    }

    private getSelectedChecklistUnitName(): string {
        return this.checklistUnitsSchedulePeriods.find(
            (checklistUnitsSchedulePeriods: IChecklist2UnitWithPeriodModel) => {
                return checklistUnitsSchedulePeriods.BusinessUnitId === this.selectedBusinessUnitId;
            },
        )?.BusinessUnitName;
    }

    protected readonly FiChecklistViewerSnackbarColorClass = FiChecklistViewerSnackbarColorClass;
}
